import { render } from "./TgMarkdown.vue?vue&type=template&id=04ddb90d"
import script from "./TgMarkdown.vue?vue&type=script&lang=js"
export * from "./TgMarkdown.vue?vue&type=script&lang=js"

import "./TgMarkdown.vue?vue&type=style&index=0&id=04ddb90d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__